import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface ITranslateProps {
	text: string;
}

const Translate: FC<ITranslateProps> = ({ text }) => {
	const { t } = useTranslation();
	return <>{t(text)}</>;
};
export { Translate };
